import { createSlice } from '@reduxjs/toolkit';

const initUserInfo = {
  userNo: '',
  id: '',
  pwd: '',
  jwtToken: '',
  name: '',
  mobile: '',
  zipCode: '',
  addr: '',
  detAddr: '',
  role: '', // 어드민/관리자/개인
  storeNo: '',
  storeName: '',
  storeImageUrl: '',
};

// 이전에 저장된 상태가 있는 경우 브라우저 메모리에 해당 상태를 사용

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: { ...initUserInfo },
  reducers: {
    userLogin: (state, action) => {
      return { ...action.payload };
    },
    userLogout: () => {
      return { ...initUserInfo };
    },
  },
});

export const { userLogin, userLogout } = userInfoSlice.actions;

export default userInfoSlice.reducer;
